// export const SENDaz='SENDaz'

export const SENDselectaddress = 'SENDselectaddress'
export const SENDcoupon = 'SENDcoupon'
export const SENDAreaCoupon = 'SENDAreaCoupon'
export const SENDpayment = 'SENDpayment'
export const SENDuserInfo = 'SENDuserInfo'
export const SENDagentText = 'SENDagentText'
export const SENDdirectorText = 'SENDdirectorText'
export const SENDreceive = 'SENDreceive'



// WEBPACK FOOTER //
// ./src/store/mutation_types.js